import { ContentDelivery, Taxonomy } from '@episerver/spa-core';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { OldDomstol, useTranslation } from 'app/hooks/useTranslations';

export const OldFeedback = (props: {
    currentPage: Taxonomy.IContent;
    layoutSettings?: ContentDelivery.StringProperty;
}) => {
    const { t } = useTranslation();

    const feedback_api = '/api/episerver/v3/feedbackolddomstol';
    const language = props.currentPage.language.name;

    const [clickedButton, setClickedButton] = useState<string>('');
    const [errorSendingMail, setErrorSendingMail] = useState<boolean>(false);
    const [userInput, setUserInput] = useState<string>('');
    const [userEmail, setUserEmail] = useState<string>('');

    const [showTextFieldValidationMessage, SetShowTextFieldValidationMessage] = useState<boolean>(false);
    const [showEmailValidationMessage, SetShowEmailValidationMessage] = useState<boolean>(false);

    function toggleYesNoButton(response: string) {
        if (response) {
            setClickedButton(response);
        } else {
            setClickedButton('');
        }
    }

    function handleUserInput(e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) {
        setUserInput(e.target?.value);
        if (e.target?.value != '') {
            SetShowTextFieldValidationMessage(false);
        }
    }

    function handleUserInputEmail(e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) {
        setUserEmail(e.target?.value);
        if (e.target?.value != '') {
            SetShowEmailValidationMessage(false);
        }
    }

    function validEmail(email: string) {
        if (email == null || email == '') {
            return false;
        }
        const re =
            /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return re.test(email);
    }

    function validText(text: string) {
        if (text == null || text == '') {
            return false;
        }
        return true;
    }

    function SendMail() {
        setErrorSendingMail(false);

        const isValidEmail = validEmail(userEmail);
        const isValidText = validText(userInput);

        if (isValidEmail && isValidText) {
            const body = {
                Email: userEmail,
                EmailText: userInput,
                PageId: props.currentPage?.contentLink?.id?.toString(),
            };

            axios
                .post(feedback_api, body)
                .then((rs) => {
                    setErrorSendingMail(false);
                    if (rs.data) {
                        setClickedButton('yes');
                    } else {
                        setErrorSendingMail(true);
                        setClickedButton('no');
                    }
                })
                .catch(function () {
                    setErrorSendingMail(true);
                    setClickedButton('no');
                });
        }

        SetShowEmailValidationMessage(!isValidEmail);
        SetShowTextFieldValidationMessage(!isValidText);
    }

    useEffect(() => {
        setClickedButton('');
    }, [props.currentPage.contentLink.id]);

    return (
        <>
            <div className="feedback _jsfeedback">
                <h2 className="smallHeader">{t(`${OldDomstol}.FeedbackTeaser`, language)}</h2>
                {clickedButton == '' && (
                    <div aria-hidden="false" className="initialResponse _jsFeedbackButtons">
                        <input
                            onClick={() => toggleYesNoButton('no')}
                            type="button"
                            className="_jsNegativeFeedbackButton"
                            value={t(`${OldDomstol}.FeedbackOptionYes`, language)}
                        />
                    </div>
                )}

                {clickedButton == 'no' && (
                    <div aria-hidden="true" className="_jsNegativeFeedback infoResponse" data-pageid="FeedbackPageID">
                        <form>
                            <div className="sr-only _jsFeedbackFormAlert"></div>
                            {props.layoutSettings != null && props.layoutSettings.value != '' && (
                                <>
                                    <p dangerouslySetInnerHTML={{ __html: props.layoutSettings.value }} />
                                </>
                            )}

                            <input
                                id="FeedbackPageID"
                                name="FeedbackPageID"
                                type="hidden"
                                value={props.currentPage.contentLink.id}
                            ></input>

                            <input className="hidden" id="hPot" type="text"></input>

                            <label htmlFor="FeedbackEmail">{t(`${OldDomstol}.FeedbackFormEmail`, language)}</label>

                            <input
                                onChange={(e) => handleUserInputEmail(e)}
                                type="email"
                                name="email"
                                id="FeedbackEmail"
                                className="input _jsFeedbackEmail"
                                placeholder={t(`${OldDomstol}.FeedbackFormYourEmail`, language)}
                            />
                            {showEmailValidationMessage && (
                                <span className="error error-email field-validation-valid field-validation-error">
                                    {t(`${OldDomstol}.FeedbackFormErrorMessagesEmail`, language)}
                                </span>
                            )}

                            <span className="hiddenTxt">{t(`${OldDomstol}.FeedbackFormEmailComment`, language)}</span>

                            <label htmlFor="FeedbackComment">
                                {t(`${OldDomstol}.FeedbackFormEmailComment`, language)}
                            </label>
                            <textarea
                                onChange={(e) => handleUserInput(e)}
                                id="FeedbackComment"
                                name="comment"
                                cols={20}
                                rows={3}
                                className="input _jsFeedbackComment"
                                placeholder={t(`${OldDomstol}.FeedbackFormYourComment`, language)}
                            ></textarea>

                            {showTextFieldValidationMessage && (
                                <span className="error error-comment field-validation-valid field-validation-error">
                                    {t(`${OldDomstol}.FeedbackFormErrorMessagesComment`, language)}
                                </span>
                            )}

                            <input
                                onClick={() => SendMail()}
                                type="button"
                                className="_jsNegativeFeedbackSubmit"
                                value={t(`${OldDomstol}.FeedbackFormBtn`, language)}
                            />
                        </form>
                    </div>
                )}

                {clickedButton == 'yes' && (
                    <div aria-hidden="true" className="infoResponse note _jsPositiveFeedback">
                        <p>{t(`${OldDomstol}.FeedbackSuccess`, language)}</p>
                    </div>
                )}

                {errorSendingMail && (
                    <div
                        aria-hidden="true"
                        className="infoResponse error-sending note alert field-validation-valid field-validation-error"
                    >
                        <p>{t(`${OldDomstol}.FeedbackFormErrorMessagesNotSent`, language)}</p>
                    </div>
                )}

                <div aria-hidden="true" className="infoResponse success note hidden">
                    <p>{t(`${OldDomstol}.FeedbackFormConfirmation`, language)}</p>
                </div>
            </div>
        </>
    );
};

export default OldFeedback;
